var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpacePlanet6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_336_31168)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_31168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.558594,
    y: 33.3486,
    width: 35.8746,
    height: 35.8746,
    rx: 17.9373,
    transform: "rotate(-67.3553 0.558594 33.3486)",
    fill: "#BCF9B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.558594,
    y: 33.3486,
    width: 35.8746,
    height: 35.8746,
    rx: 17.9373,
    transform: "rotate(-67.3553 0.558594 33.3486)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_336_31168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5918,
    cy: 23.9227,
    rx: 19.4619,
    ry: 19.0803,
    transform: "rotate(-67.3553 20.5918 23.9227)",
    fill: "#9BEF86"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_336_31168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6482,
    cy: 24.5315,
    rx: 12.0311,
    ry: 11.7446,
    transform: "rotate(-67.3553 14.6482 24.5315)",
    fill: "#BFF8B1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter3_f_336_31168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.09614,
    cy: 3.04932,
    rx: 5.09614,
    ry: 3.04932,
    transform: "matrix(0.203731 -0.979027 0.980524 0.196399 33.2002 30.4456)",
    fill: "#BFF8B1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_336_31168",
    x: 0.558594,
    y: 0.239746,
    width: 46.9209,
    height: 46.9211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_336_31168"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113628 0 0 0 0 0.267573 0 0 0 0 0.354167 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_336_31168"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_336_31168",
    x: -28.5508,
    y: -25.4883,
    width: 98.2852,
    height: 98.822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_336_31168"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_336_31168",
    x: -22.1426,
    y: -12.4607,
    width: 73.5811,
    height: 73.9844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_336_31168"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_336_31168",
    x: 19.0625,
    y: 6.02954,
    width: 36.332,
    height: 40.0513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_336_31168"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_31168"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.558594,
    y: 33.3486,
    width: 35.8746,
    height: 35.8746,
    rx: 17.9373,
    transform: "rotate(-67.3553 0.558594 33.3486)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacePlanet6);
export default __webpack_public_path__ + "static/media/spacePlanet6.16b7b31731f504bab3cc1138b27ec771.svg";
export { ForwardRef as ReactComponent };